import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { MdCheckCircle } from 'react-icons/md';
import type { TFormQuestion } from '@onesource/services';
import type { TSubmitFormAnswer } from '@onesource/schemas';
import { getAcceptButtonLabel } from '@onesource/schemas';

interface AcceptQuestionProps {
  question: TFormQuestion;
  answer: TSubmitFormAnswer;
  onAnswerChange: (answer: TSubmitFormAnswer) => void;
  disabled?: boolean;
}

export const AcceptQuestion = ({ question, answer, onAnswerChange, disabled = false }: AcceptQuestionProps) => {
  const buttonLabel = getAcceptButtonLabel(question.metadata);
  const isAccepted = answer.textAnswer === 'accepted';

  const handleAccept = () => {
    onAnswerChange({ ...answer, textAnswer: 'accepted' });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <Button
        variant="contained"
        onClick={handleAccept}
        disabled={disabled || isAccepted}
        sx={{
          bgcolor: '#ff4d6d',
          color: 'white',
          px: 3,
          py: 1,
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': { bgcolor: '#e63956' },
          '&:disabled': { bgcolor: isAccepted ? '#4caf50' : '#ccc', color: 'white' },
        }}
      >
        {buttonLabel}
      </Button>
      {isAccepted && (
        <Chip
          icon={<MdCheckCircle size={16} />}
          label="Accepted"
          size="small"
          sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 500 }}
        />
      )}
    </Box>
  );
};
